<template>
  <div class="share-modal-wrapper">
    <div class="share-modal-overlay" @click="hideShareModal()"></div>
    <div class="share-modal-main-cnt">
      <!-- Button Box -->
      <div class="button-cnt">
        <b-button
          data-href="https://cardinals.vipfanportal.com/2021holidays/"
          data-layout="button"
          data-size="large"
          target="_blank"
          href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fazcardinals.com%2Fhappyholidays2021&amp;src=sdkpreparse"
          class="circle-button box-button"
        >
          <div class="button-img-cnt">
            <img
              src="@/assets/images/icons/share-modal/facebook.svg"
              alt="Facebook"
            />
          </div>
        </b-button>
        <h3 class="button-subtitle">Facebook</h3>
      </div>
      <!-- Email -->
      <div class="button-cnt">
        <b-button
          href="mailto:?subject=Check out Cardinalville, the Arizona Cardinals Christmas Card.&body=Check out Cardinalville, the Arizona Cardinals Christmas Card. www.azcardinals.com/happyholidays2021"
          class="circle-button box-button"
        >
          <div class="button-img-cnt">
            <img
              src="@/assets/images/icons/share-modal/email.svg"
              alt="Email Button"
            />
          </div>
        </b-button>
        <h3 class="button-subtitle">Email</h3>
      </div>
      <div class="x-button-cnt">
        <b-button @click="hideShareModal()">
          <img
            src="@/assets/images/icons/share-modal/close button.svg"
            alt="X button"
          />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { shareButtons } from "@/assets/data/shareButtonsData.js";

export default {
  name: "ShareModal",
  data() {
    return {
      buttonCards: shareButtons,
    };
  },
  methods: {
    hideShareModal() {
      this.$store.dispatch("hideShareModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.share-modal-wrapper {
  .share-modal-overlay {
    position: fixed; /* Sit on top of the page content */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  }
  .share-modal-main-cnt {
    z-index: 3;
    $height: 295px;
    $width: 644px;
    height: $height;
    width: $width;
    border-radius: 4px;
    background: linear-gradient(180deg, #e4e5e4 0%, #cecece 100%);
    box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 56px;
    position: fixed;
    left: calc(100vw / 2);
    top: calc((100vh - 80px) / 2);
    margin-top: -$height/2;
    margin-left: -$width/2;
    .x-button-cnt {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
@media only screen and (max-width: $md) {
  .share-modal-wrapper {
    .share-modal-main-cnt {
      $height: 650px;
      $width: 300px;
      height: $height;
      width: $width;
      margin-top: -$height/2;
      margin-left: -$width/2;
      flex-direction: column;
      gap: 20px;
    }
  }
}
</style>
